import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponentComponent } from './components/header-component/header-component.component';
import { MenuComponentComponent } from './components/menu-component/menu-component.component';
import { LinkRepositoryComponent } from './components/link-repository/link-repository.component';
import { ModalComponent } from '../shared/components/modal/modal.component';
import { CodeRenderComponent } from './components/code-render/code-render.component';
import { ButtonComponent } from './components/button/button.component';
import { CodeRenderTabsComponent } from './components/code-render-tabs/code-render-tabs.component';
import { ModalMenuComponent } from './components/modal-menu/modal-menu.component';

@NgModule({
  declarations: [
    HeaderComponentComponent,
    MenuComponentComponent,
    LinkRepositoryComponent,
    ModalComponent,
    CodeRenderComponent,
    ButtonComponent,
    CodeRenderTabsComponent,
    ModalMenuComponent,
  ],
  imports: [CommonModule],
  exports: [
    HeaderComponentComponent,
    MenuComponentComponent,
    LinkRepositoryComponent,
    ModalComponent,
    CodeRenderComponent,
    ButtonComponent,
    CodeRenderTabsComponent,
    ModalMenuComponent,
  ],
})
export class SharedModule {}
